const util = require("@/libs/utils")

const WEB_HOST = process.env.WEB_HOST;
module.exports = {
  postNavigationMessage(path, target="_top") {
    window.parent && window.parent.postMessage({
      type: 'sdk',
      name: 'navigateTo',
      params: { path, target }
    }, '*')
  },
  postAppMessage(payload) {
    window.parent && window.parent.postMessage({
      type: 'ikeaapp',
      name: 'ikeaapp',
      params: payload
    }, '*')
  },
  open(page, params) {
    const eventPayload = {
      type: 'sdk',
      name: 'navigateTo',
      params: {path: null}
    }

    switch (page) {
      case 'family_miniprogram':
        this.postNavigationMessage('/ikea-family/')
        break;
      case 'coupon':
        this.postNavigationMessage('/profile/coupon')
        break;
      case 'order_detail':
        this.postNavigationMessage(`/profile/orderDetail?orderCode=${params.id}`)
        break;
      case 'cms_page':
        this.postNavigationMessage(`/modules/page/cms/page.html?id=${params.id}`)
        break;
      case 'link':
        this._openLink(params.link)
        break;
      case 'product':
        const productFullId = params.type === 'SPR' ? `s${params.id}` : params.id
        this.postNavigationMessage(`/p/${productFullId}`)
        break;
      case 'customer_service':
        this.postNavigationMessage('/customer-service')
        break;
      case 'customer_service_tel':
        break;
      case 'assembly_service_introduction':
        this.postNavigationMessage('/customer-service')
        break;
      case 'web':
        this.postNavigationMessage(encodeURIComponent(params.path) + params.additionalParams || '', '_blank')
        break;
      case 'login':
        this.postNavigationMessage('/profile/login')
        break;
      case 'shareInfo':
        // TODO: WEB 暂不支持
        this.postAppMessage({
          page,
          params
        })
        break;
      case 'add_multi_product_to_cart':
        // TODO: WEB 暂不支持
        this.postAppMessage({
          page,
          params
        })
        break;
    }
  },
  // TODO move link resolve logic to server
  _openLink(link) {
    this.resolveWebURL(link.resolvedUrl)
  },

  resolveWebURL(url) {

    const uri = util.parseURL(url)
    console.log(uri)
    const params = uri.params

    if (uri.host === 'ikeaapp') {
      switch (uri.path) {
        // /modules/page/cms/page.html?id={{id}}
        case '/cms/page':
          this.postNavigationMessage(`/modules/page/cms/page.html?${uri.query}`)
          break
        case '/web':
          this.postNavigationMessage(encodeURIComponent(url), '_blank')
          break
        case '/scan':
          // TODO: WEB 暂不支持
          break
        case '/login':
          this.postNavigationMessage('/profile/login')
          break
        case '/product':
          const productFullId = params.type === 'SPR' ? `s${params.id}` : params.id
          this.postNavigationMessage(`/p/${productFullId}`)
          break
        case '/ins_detail':
          // TODO: WEB 暂不支持
          this.postAppMessage({
            url
          })
          break
        case '/plp':
        case '/product_list':
          this.postNavigationMessage(`/cat/${params.id}`)
          break
        case '/miniprogram':
          // TODO: WEB 暂不支持
          break
        case '/goSearch':
          this.postNavigationMessage(`/guide/search`)
          break
        case '/search':
          // TODO: WEB 暂不支持
          this.postAppMessage({
            url
          })
          break
        case '/tab_index':
          // TODO: WEB 暂不支持
          this.postAppMessage({
            url
          })
          break
        case '/sub_catalog':
          // TODO: WEB 暂不支持
          this.postAppMessage({
            url
          })
          break
        case '/customer_service_tel':
          // TODO: WEB 暂不支持
          this.postAppMessage({
            url
          })
          break
        case '/customer_service':
          this.postNavigationMessage('/customer-service/')
          break
        case '/assembly_service_introduction':
          this.postNavigationMessage('/customer-service/services/assembly/')
          break
        case '/shopping_cart':
          this.postNavigationMessage('/pay/cart')
          break
        case '/add_multi_product_to_cart':
          // TODO: WEB 暂不支持
          this.postAppMessage({
            url
          })
          break
        case '/popCurrent':
          window.top && window.top.history.back()
          return;
      }
    } else {
      location.href = url;
      this.postNavigationMessage(url, '_blank')
    }
  },
}



// WEBPACK FOOTER //
// ./src/libs/router/platform/web.js